<template>
    <svg class="venn-container" :style="{pointerEvents: pointerEvents}">
        <!-- My venn diagram -->
        <venn-diagram-svg
            ref="svg"
            :width="width + '%'"
            :height="height + '%'"
            class="venn-diagram-svg"
        ></venn-diagram-svg>

        <!-- My venn controllers -->
        <venn-controllers v-if="hasMounted" :rootElement="$el.querySelector('.venn-diagram-svg')"></venn-controllers>
    </svg>
</template>

<script>
import { mapState } from 'vuex'
import VennDiagramSvg from '@/assets/svg/venn-diagram.svg'
import VennControllers from './VennControllers'
import { tween } from 'popmotion'

export default {
    components: {
        VennDiagramSvg,
        VennControllers
    },

    data() {
        return {
            hasMounted: false,
            width: 100,
            height: 100
        }
    },

    computed: {
        ...mapState(['scene', 'layout']),

        horizontal() {
            return this.layout === 'horizontal'
        },

        fullscreen() {
            return (
                this.scene === 'landing' ||
                this.scene === 'intro' ||
                this.scene === 'overview'
            )
        },

        pointerEvents() {
            if (this.scene === 'landing' || this.scene === 'intro') {
                return 'none'
            } else {
                return 'auto'
            }
        },

        width_() {
            return this.fullscreen ? 100 : this.horizontal ? 50 : 100
        },

        height_() {
            return this.fullscreen ? 100 : this.horizontal ? 100 : 50
        }
    },

    watch: {
        width_(to) {
            tween({ from: this.width, to }).start(v => (this.width = v))
        },

        height_(to) {
            tween({ from: this.height, to }).start(v => (this.height = v))
        }
    },

    mounted() {
        this.$nextTick(() => (this.hasMounted = true))
    }
}
</script>

<style lang="stylus" scoped>
.venn-container
    position: fixed
    left: 0
    bottom: 0
    width: 100%
    height: calc(100% - 50px)
    transform-origin: top left
    transition: opacity 0.3s

    @media (min-width: small)
        height: calc(100% - 80px)

.venn-diagram-svg
    width: 100%
    height: 100%
</style>

<style>
.venn-diagram-svg {
    cursor: pointer;
}
</style>


